import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { cardTitleVariants } from "./styles";

export interface CardTitleProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const CardTitle = ({ className, ref, ...props }: CardTitleProps) => (
  <div ref={ref} data-slot="card-title" className={cn(cardTitleVariants(), className)} {...props} />
);
